import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  RadioGroup,
  Radio,
} from '@fluentui/react-components';
import {
  ADD_KEYWORDS_BY_ENTRY,
  ADD_KEYWORDS_BY_SELECTION,
} from './keyword-methods';

export const KeywordInput = ({
  entryControl,
  isDisabled,
  isSelectDisabled,
  keywordsMethod,
  onChangeKeywordsMethod,
  selectControl,
}) => {
  const i18n = useContext(I18nContext);
  const selectLabel = i18n.getString(_TL_('Select keywords'));
  const entryLabel = i18n.getString(_TL_('Enter keywords'));

  const onSelectRadio = useCallback((e, data) => {
    onChangeKeywordsMethod(data.value);
  }, [onChangeKeywordsMethod]);

  return (
    <RadioGroup
      className="keywords-radio-group"
      disabled={isDisabled}
      onChange={onSelectRadio}
      value={keywordsMethod}
    >
      <Radio
        disabled={isSelectDisabled}
        label={selectLabel}
        value={ADD_KEYWORDS_BY_SELECTION}
      />
      {keywordsMethod === ADD_KEYWORDS_BY_SELECTION && selectControl}
      <Radio
        label={entryLabel}
        value={ADD_KEYWORDS_BY_ENTRY}
      />
      {keywordsMethod === ADD_KEYWORDS_BY_ENTRY && entryControl}
    </RadioGroup>
  );
};

KeywordInput.propTypes = {
  entryControl: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isSelectDisabled: PropTypes.bool.isRequired,
  keywordsMethod: PropTypes.oneOf([
    ADD_KEYWORDS_BY_ENTRY,
    ADD_KEYWORDS_BY_SELECTION,
  ]),
  onChangeKeywordsMethod: PropTypes.func.isRequired,
  selectControl: PropTypes.node.isRequired,
};

KeywordInput.defaultProps = {
  keywordsMethod: null,
};
